import React from 'react';
import SideBar from '../../components/layout/sidebar/SideBar';
import TopBar from '../../components/layout/topbar/TopBar';
// import { Outlet } from 'react-router-dom';

const Dashboard = () => {
    return (
        <div >
             <TopBar />
            <SideBar />
                {/* <div style={{ backgroundColor: '', marginTop: "", padding: "",  marginLeft: "", marginRight:""  }}>
                    <Outlet />
               </div> */}
        </div>
    );
};

export default Dashboard;